export default class InputPointOfInterest
{
  constructor(id, poi, image) 
  {
    // TODO Validation

    if(id)
    {
      this.id = id;
    }
    
    this.poi = poi;
    this.image = image;
  }    
}